import React from 'react'

/**
 * Lucide `chevron-down` (ISC) 원본 그대로 — 24 viewBox, path "m6 9 6 6 6-6".
 * DESIGN_SYSTEM §9: 아이콘은 라이브러리 원본을 쓰고 strokeWidth 만 1 로 얇게 한다.
 * 네이티브 select 위에 얹는 용도라 `aria-hidden`.
 */
export const ChevronDown = () => (
	<svg
		className="mnPaySelectChevron"
		xmlns="http://www.w3.org/2000/svg"
		width={18}
		height={18}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth={1}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
	>
		<path d="m6 9 6 6 6-6" />
	</svg>
)
